var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:['container-tag', _vm.form.editing === _vm.field.uuid ? 'editing' : '']},[_vm._v(" "+_vm._s(_vm.field.remark ? (_vm.componentTag + "." + (_vm.field.remark)) : _vm.componentTag)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }